import {UPLOAD_START, UPLOAD_SUCCESS, UPLOAD_FAIL, UPLOAD_RESET} from './constants';
import {UploadActions, UploadState} from './types';

const initialState: UploadState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: UploadActions,
): UploadState => {
  switch (action.type) {
    case UPLOAD_START:
      return {
        ...initialState,
        loading: true,
      };
    case UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case UPLOAD_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UPLOAD_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
